export default {
      id: "ivd-usage",
      viewBox: "0 0 65 35",
      url: __webpack_public_path__ + "sprite.svg#ivd",
      toString: function () {
        return this.url;
      }
    }